import { ListsManagementPage as ListsManagement } from './src/page/ListsManagementPage';

export const ListsManagementPage = ListsManagement;
